var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: {
                title: _vm.$t("login.resendActivationEmail"),
                isShowFollow: false,
              },
              on: { open: _vm.opened },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticStyle: { margin: "20px 60px 0" } },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    staticClass: "login-form",
                    attrs: {
                      model: _vm.form,
                      rules: _vm.rules,
                      autocomplete: "on",
                      "label-position": "top",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("home.account") + "：",
                          prop: "username",
                        },
                      },
                      [
                        _c("el-input", {
                          directives: [
                            { name: "uppercase", rawName: "v-uppercase" },
                            { name: "trim", rawName: "v-trim" },
                            { name: "fth", rawName: "v-fth" },
                          ],
                          ref: "username",
                          style: "width: 100%",
                          attrs: {
                            name: "username",
                            autocomplete: "on",
                            type: "text",
                            tabindex: "1",
                            maxlength: "30",
                          },
                          model: {
                            value: _vm.form.username,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "username", $$v)
                            },
                            expression: "form.username",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("home.email"), prop: "email" } },
                      [
                        _c("el-input", {
                          directives: [
                            { name: "trim", rawName: "v-trim" },
                            { name: "fth", rawName: "v-fth" },
                          ],
                          ref: "email",
                          style: "width: 100%",
                          attrs: { name: "email" },
                          model: {
                            value: _vm.form.email,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "email", $$v)
                            },
                            expression: "form.email",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "text-align": "center" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: {
                          "text-align": "center",
                          margin: "20px 40px 20px 0",
                          width: "100px",
                        },
                        attrs: { type: "primary" },
                        on: { click: _vm.sendActivationEmail },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("btn.send")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: {
                          "text-align": "center",
                          margin: "20px 0",
                          width: "100px",
                        },
                        attrs: { type: "primary" },
                        on: { click: _vm.handleClose },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("btn.close")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }